import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FormProps } from "../../../interfaces/form-action-interfaces";
import { Card, CardBody, CardFooter, CardHeader } from "../../forms/components/card";
import { FileUploadV2 } from "../../forms/components/file-upload-v2";
import { Input, SelectInput, SelectWithText } from "../../forms/components/input";
import { Toggle } from "../../forms/components/toggle";
import { useBrandFormStore } from "../states/brand.state";

const BrandFormScreen = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { formParam, setFormParam, forms, setForms, generateForms, onSubmitForm, submitDone, reset } = useBrandFormStore();

  useEffect(() => {
    if (location) {
      setFormParam(location.state as FormProps);
      generateForms(location.state as FormProps);
    }
  }, [location]);

  useEffect(() => {
    console.log(submitDone);
    if (submitDone) {
      reset();
      navigate(-1)
    }
  }, [submitDone])

  return (
    <form onSubmit={e => {
      e.preventDefault();
      onSubmitForm();
    }}>
      <Card>
        <CardHeader title={`${formParam?.action} ${formParam?.title}`}/>  
        <CardBody>
          {
            forms?.map((v, k) => {
              switch (v?.type) {
                case 'email':
                  return <Input
                    key={k}
                    title={v.title}
                    type={v.type}
                    placeholder={v.placeholder}
                    name={v.name}
                    value={v.value}
                    disabled={v.disabled}
                    onChange={(e) => {
                      setForms(k, e.target.value);
                    }}
                  />
                case 'password':
                  return <Input
                    key={k}
                    title={v.title}
                    type={v.type}
                    placeholder={v.placeholder}
                    name={v.name}
                    value={v.value}
                    disabled={v.disabled}
                    onChange={(e) => {
                      setForms(k, e.target.value);
                    }}
                  />
                case 'text':
                  return <Input
                    key={k}
                    title={v.title}
                    type={v.type}
                    placeholder={v.placeholder}
                    name={v.name}
                    value={v.value}
                    disabled={v.disabled}
                    onChange={(e) => {
                      setForms(k, e.target.value);
                    }}
                  />
                case 'toggle':
                  return <Toggle
                    key={k}
                    title={v.title}
                    checked={v.value}
                    disabled={v.disabled}
                    name={v.name}
                    onChange={e => {
                      const target = e.target;
                      const value = target.type === 'checkbox' ? target.checked : target.value;
                      setForms(k, value);
                    }}
                  />
                case 'select-with-text':
                  return <SelectWithText 
                    key={k}
                    title={v.title}
                    name={v.name}
                    selectData={v.selectData}
                    type={v.type}
                    value={v.value}
                    disabled={v.disabled}
                    onChangeSelectWithText={e => {
                      console.log(e)
                      setForms(k, e);
                    }}
                    onInputChange={v.onInputChange}
                  />
                case 'file-upload-v2':
                  return <FileUploadV2
                    key={k}
                    title={v.title}
                    multiple={false}
                    description={'Upload File'}
                    name={v.name}
                    onUploadDone={(e) => {
                      setForms(k, e.data?.id);
                    }}
                    value={v.value}
                    disabled={v.disabled}
                    />; 
                default:
                  return <div key={k}></div>
              }
            })
          }
        </CardBody>
        <CardFooter>
          <button 
            type="submit" 
            className="btn btn-success btn-lg"
            onClick={(e) => {
              e.preventDefault();
              onSubmitForm();
            }}>
              Submit
          </button>
        </CardFooter>
      </Card>  
    </form>
  );
}

export default BrandFormScreen;